import { Card, CircularProgress, Grid, IconButton, Paper, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, tableCellClasses } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Button, CardBody, CardHeader, Spinner, Table } from 'reactstrap';
import { styled } from '@mui/material/styles';
import { DataUsuarios, UsuarioRol, getUserEmpty, getUserEmptyRol } from '../../interfaces/UsuariosRoles';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { GiArchiveResearch } from "react-icons/gi";
import FeedIcon from '@mui/icons-material/Feed';
import AlertService from '../../services/AlertService';
import CertificadoService from '../../services/CertificadoService';
import IResearchService from '../../services/IResearchService';
import { CasUserContext, useCasUserContext } from '../../services/casUserContext';
import { useNavigate } from 'react-router-dom';
import UsuarioService from '../../services/UsuarioService';
import { ModalDetalleUsuario } from './ModalDetalleUsuario';
import { ModalEditarUsuario } from './ModalEditarUsuario';
import * as XLSX from 'xlsx';
import { ModalEditorOrcID } from './ModalEditorOrcID';
import { PersonaInvDTO, VoidPersonaInvDTO } from '../../interfaces/Usuarios/PersonaInvDTO';
import { ModalX } from './ModelX';
import { IResearchForm } from './IResearchForm';
import { GetVoidScivalAutorDTO, ScivalAutorDTO } from '../../interfaces/IResearch/InvestigadorScopusDTO';
const alertaService = new AlertService;
const certificadoService = new CertificadoService;
const usuarioservice = new UsuarioService;
const iResearchService = new IResearchService;

interface Column {
    id: 'identificacion' | 'usuario' | 'nombres' | 'rolprincipal' | 'rolesextra' | 'unidad' | 'autorizado' | 'orcid' | 'scholarid' | 'scopusid' | 'opciones';
    label: string;
    minWidth?: number;
    align?: 'right';
    format?: (value: number) => string;

}

const columns: readonly Column[] = [
    {
        id: 'identificacion',
        label: 'Identificación',
    },
    {
        id: 'usuario',
        label: 'Usuario',
    },
    {
        id: 'nombres',
        label: 'Nombres',
    },
    {
        id: 'orcid',
        label: 'OrcID',
    },
    {
        id: 'scholarid',
        label: 'Google scholar ID',
    },
    {
        id: 'scopusid',
        label: 'Scopus ID',
    },
    {
        id: 'opciones',
        label: 'Opciones',
    }
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));


function exportToExcel(data: Array<PersonaInvDTO>, fileName: string) {
    const filteredData = data.map(item => ({
        Identificacion: item.numeroidentificacion,
        Usuario: item.email,
        Nombres: item.nombreCompleto,
        OrcID: item.orcid,
        Google_Scholar_ID: item.scholarid,
        Scopus_ID: item.scopusid
    }));
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;

    a.click();

    URL.revokeObjectURL(url);
}

const usuarioService = new UsuarioService();

export default function TablaUsuario(props: DataUsuarios) {
    const data = [
        { Nombre: 'John', Edad: 30 },
        { Nombre: 'Jane', Edad: 25 },
        { Nombre: 'Bob', Edad: 40 },
    ];

    const handleExport = () => {
        exportToExcel(usuariosCreados, 'Usuarios.xlsx');
    };
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    let history = useNavigate()
    const token = casUserContext.token;
    const username = casUserContext.userData.username;
    const roles = casUserContext.userData.roles;
    const [ready, SetReady] = useState(false);
    let [usuariosCreados, setUsuariosCreados] = useState<Array<PersonaInvDTO>>([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
    const [page, setPage] = useState(0);
    const [open, setOpen] = useState(false);
    const [openEditar, setOpenEditar] = useState(false);
    const [modalEditorOrcID, setModalEditorOrcID] = useState(false);
    const [modalResearch, setModalResearch] = useState(false);
    const [autorFlag, setAutorFlag] = useState(false);
    let [dataUsuario, setDataUsuario] = useState<PersonaInvDTO>(() => VoidPersonaInvDTO());
    let [dataEditar, setDataEditar] = useState<PersonaInvDTO>(VoidPersonaInvDTO());
    let [autor, setAutor] = useState<ScivalAutorDTO>(GetVoidScivalAutorDTO());
    const fetchData = async () => {
        try {
            alertaService.showLoading("Cargando Datos...");
            usuarioservice.GetListUsuarios(token)
                .then((data) => {
                    if (data.status.isSuccessfully) {
                        setUsuariosCreados(data.listData);
                        SetReady(true)
                    }
                })
                .catch((error) => console.error(error));
            alertaService.hideLoading();
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [token]);

    const constFilteredCert = usuariosCreados.filter((usuario) => {
        if (usuario.nombreCompleto.toUpperCase().includes(globalFilter.toUpperCase()) || usuario.numeroidentificacion.toUpperCase().includes(globalFilter.toUpperCase()) || usuario.email.toUpperCase().includes(globalFilter.toUpperCase())) {
            return true;
        }
        return false;
    });

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };


    const cerrarModal = () => {
        setOpen(false)
        setOpenEditar(false)
        setModalEditorOrcID(false)
        setModalResearch(false)
        setAutor(GetVoidScivalAutorDTO())
        setAutorFlag(false)
    }

    const abrirModal = (data: PersonaInvDTO) => {
        setDataUsuario(data);
        setOpen(true)
        return true
    }

    const abrirModalEditar = (data: PersonaInvDTO) => {
        setOpenEditar(true)
        setDataEditar(data);
    }

    const abrirModalEditorOrcID = (data: PersonaInvDTO) => {
        setModalEditorOrcID(true)
        setDataEditar(data);
    }

    const mostrarEliminar = (titulo: string, mensaje: string, idUser: number) => {
        alertaService.alertaEliminarUsuario(titulo, mensaje, idUser, token);
    }

    const abrirModalResearch = async (id: number) => {
        setModalResearch(true);
        try {
            alertaService.showLoading("Consultando...");
            await iResearchService.GetScivalAutorActivo(token, id)
                .then((data) => {
                    console.log(data)
                    if (data.status.isSuccessfully) {
                        setAutor(data.data);
                    }
                })
                .catch((error) => console.error(error));
            alertaService.hideLoading();
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setAutorFlag(true);
        }
    }

    return (
        <>
            {ready ?
                <Card>
                    <ModalEditarUsuario isOpen={openEditar} toggle={cerrarModal} data={dataEditar} />
                    <ModalEditorOrcID isOpen={modalEditorOrcID} toggle={cerrarModal} data={dataEditar} />
                    <ModalX isOpen={modalResearch} toggle={cerrarModal} data={dataEditar} titulo={'IResearch'}>
                        {autorFlag ? <IResearchForm usuario={autor} token={token} /> : <CircularProgress />}
                    </ModalX>
                    <CardHeader>
                        <strong>Usuarios</strong>
                        <div style={{ padding: '5px' }}>
                            <Button style={{ borderRadius: '5px' }} onClick={handleExport} color='primary' variant="contained" >Descargar excel</Button>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <br />
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <Card>
                                <CardBody>
                                    <div >
                                        <div className='my-2 text-right'>
                                            <input type="text" className='p-2 text-gray-600 border border-gray-300 rounded outline-indigo-700' placeholder='Buscar...'
                                                onChange={e => setGlobalFilter(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <TableContainer sx={{ maxHeight: 600 }}>
                                        <Table stickyheader="true" aria-label="sticky table" >
                                            <TableHead>
                                                <TableRow>
                                                    {columns.map((column) => (
                                                        <StyledTableCell
                                                            style={{ minWidth: column.minWidth }}
                                                            key={column.id}
                                                            align={column.align}>
                                                            {column.label}
                                                        </StyledTableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {constFilteredCert.length > 0 ? constFilteredCert
                                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    .map((row, index) => {
                                                        return (

                                                            <StyledTableRow key={index}>
                                                                <ModalDetalleUsuario isOpen={open} toggle={cerrarModal} data={dataUsuario} />
                                                                <StyledTableCell align="left">{row.numeroidentificacion}</StyledTableCell>
                                                                <StyledTableCell align="left"> {row.email} </StyledTableCell>
                                                                <StyledTableCell align="left"> {row.nombreCompleto} </StyledTableCell>
                                                                <StyledTableCell align="left"> {row.orcid} </StyledTableCell>
                                                                <StyledTableCell align="left"> {row.scholarid} </StyledTableCell>
                                                                <StyledTableCell align="left"> {row.scopusid} </StyledTableCell>
                                                                <StyledTableCell align="center">
                                                                    <Grid container spacing={1}>
                                                                        {usuarioService.authorizedByRol(142, roles) ?
                                                                            <Grid item xs={6} sm={6}>
                                                                                <IconButton color='primary' onClick={() => abrirModalEditar(row)} component="span">
                                                                                    <EditIcon />
                                                                                </IconButton>
                                                                            </Grid>
                                                                            : <></>}
                                                                        {usuarioService.authorizedByRol(153, roles) ?
                                                                            <Grid item xs={6} sm={6}>
                                                                                <IconButton color='primary' onClick={() => abrirModalEditorOrcID(row)} component="span">
                                                                                    <EditIcon />
                                                                                </IconButton>
                                                                            </Grid>
                                                                            : <></>
                                                                        }
                                                                        <Grid item xs={6} sm={6}>
                                                                            <IconButton color='primary' onClick={() => abrirModal(row)} component="span">
                                                                                <FeedIcon />
                                                                            </IconButton>
                                                                        </Grid>
                                                                        {/* {usuarioService.authorizedByRol(147, roles) ?
                                                                            <Grid item xs={6} sm={6}>
                                                                                <IconButton color='primary' onClick={() => abrirModalResearch(row.idpersona)} component="span">
                                                                                    <GiArchiveResearch />
                                                                                </IconButton>
                                                                            </Grid>
                                                                            : <></>
                                                                        } */}
                                                                    </Grid>
                                                                </StyledTableCell>
                                                            </StyledTableRow>
                                                        );
                                                    }) :
                                                    <StyledTableRow key={0}>
                                                        <StyledTableCell align="center">No se encontraron usuarios</StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                        <StyledTableCell align="center"></StyledTableCell>
                                                    </StyledTableRow>
                                                }

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <TablePagination
                                        rowsPerPageOptions={props.rowsPerPage}
                                        component="div"
                                        count={usuariosCreados.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                    />
                                </CardBody>
                            </Card>
                        </Paper>
                    </CardBody>
                </Card> :
                <Spinner
                    color="primary"
                    style={{
                        height: '3rem',
                        width: '3rem'
                    }}
                >
                    Loading...
                </Spinner>
            }
        </>
    )
}